import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import iq_api from "../../services/iqApi";
import { useUser } from "../../context/UserContext";
import Alert from "../HtmlElements/Alert";

const TamExpansionTool = () => {
  const { user } = useUser();
  const userId = user?.user_id;

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [question, setQuestion] = useState("");

  const [isGenerating, setIsGenerating] = useState(false);

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [mainError, setMainError] = useState("");
  const [mainSuccessMessage, setMainSuccessMessage] = useState("");

  const [list, setList] = useState([]);
  const [loadingList, setLoadingList] = useState(false);

  // ---------------- Fetch Listing ----------------
  // const fetchList = async () => {
  //   try {
  //     setLoadingList(true);
  //     const res = await iq_api.get(
  //       `/growth_expansion_strategy_word/list?user_id=${userId}`
  //     );
  //     setList(res.data || []);
  //     setLoadingList(false);
  //   } catch (err) {
  //     console.error("List load error", err);
  //     setLoadingList(false);
  //   }
  // };
  const fetchList = async () => {
    try {
      const res = await iq_api.get("/growth_expansion_strategy_word/list", {
        params: { user_id: userId },
      });

      setList(Array.isArray(res.data?.jobs) ? res.data.jobs : []);
    } catch (err) {
      console.error(err);
      setList([]);
    }
  };

  useEffect(() => {
    fetchList();
    const interval = setInterval(() => {
      fetchList();
    }, 30000); // 30 seconds
    return () => clearInterval(interval);
  }, [userId]);

  // -------------- Handle Create ------------------
  const handleCreate = async () => {
    if (!companyName.trim() || !question.trim()) {
      setError("Both Company Name and Question are required.");
      setTimeout(() => setError(""), 4000);
      return;
    }

    try {
      setShowModal(false);
      setIsGenerating(true);

      const payload = {
        company_name: companyName,
        question,
        max_turns: 80,
        generate_pdf: true,
        output_dir: "/home/ubuntu/growthiq/growthiq_user_backend/tmp_word",
        user_id: userId,
      };

      const res = await iq_api.post(
        "/growth_expansion_strategy_word",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!res.data?.task_id) throw new Error("task_id missing");

      setSuccessMessage("Request submitted successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);

      setIsGenerating(false);

      // reload list after creating entry
      fetchList();
    } catch (err) {
      console.error(err);
      setMainError("Failed to create TAM expansion.");
      setTimeout(() => setMainError(""), 5000);
      setIsGenerating(false);
    }
  };

  // ---------- Handle Download ----------
  const handleDownload = async (taskId) => {
    try {
      const res = await iq_api.get(
        `/growth_expansion_strategy_word/${taskId}/download`,
        { responseType: "blob" }
      );

      const blob = new Blob([res.data]);
      const link = document.createElement("a");

      const type = res.headers["content-type"];
      const ext = type.includes("pdf")
        ? "pdf"
        : type.includes("word")
        ? "docx"
        : "file";

      link.href = URL.createObjectURL(blob);
      link.download = `TAM_Expansion_${taskId}.${ext}`;
      link.click();
    } catch (err) {
      console.error("Download error", err);
      alert("Failed to download result.");
    }
  };

  // ---------- Reset form when modal opens ----------
  const openModal = () => {
    setCompanyName("");
    setQuestion("");
    setError("");
    setSuccessMessage("");
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div
            className="all_acccounts_wrapper"
            style={{
              backgroundColor: "#fff",
              padding: 20,
              borderRadius: 12,
              maxWidth: "99%",
              minHeight: "100vh",
            }}
          >
            <div className="p-4">
              {mainSuccessMessage && (
                <Alert type="success" message={mainSuccessMessage} />
              )}
              {mainError && <Alert type="danger" message={mainError} />}

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>TAM Expansion Generator</h4>

                <div>
                  <button
                    className="btn btn-outline-secondary m-2"
                    style={{
                      padding: "5px 10px",
                      backgroundColor: "rgb(35, 36, 40)",
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "rgb(255, 255, 255)",
                      border: "none",
                      borderRadius: "6px",
                    }}
                    onClick={fetchList}
                    disabled={loadingList}
                  >
                    <FeatherIcon.RefreshCw size={14} /> Refresh
                  </button>

                  <button
                    className="btn btn-primary"
                    // style={{
                    //   backgroundColor: "rgb(35,36,40)",
                    //   borderRadius: 6,
                    //   padding: "5px 10px",
                    //   fontSize: 13,
                    //   color: "#fff",
                    // }}
                    style={{
                      padding: "5px 10px",
                      backgroundColor: "rgb(35, 36, 40)",
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "rgb(255, 255, 255)",
                      border: "none",
                      borderRadius: "6px",
                    }}
                    onClick={openModal}
                    disabled={isGenerating}
                  >
                    <FeatherIcon.FilePlus size={14} /> Create TAM Expansion
                  </button>
                </div>
              </div>

              {isGenerating && (
                <div className="text-center p-5">
                  <div className="spinner-border text-primary mb-3" />
                  <p className="fw-semibold">
                    Submitting your request… Please wait.
                  </p>
                </div>
              )}

              {/* -------- LISTING TABLE -------- */}
              <div className="mt-4">
                <h5>Generated Documents</h5>

                <div className="table-responsive">
                  <table className="table custom-resizable-table">
                    <thead className="table-light">
                      <tr className="custom-resizable-table-header">
                        <th>#</th>
                        <th>Company Name</th>
                        <th>Question</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Completed At</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {list.length === 0 && (
                        <tr className="gtr-row">
                          <td colSpan="6" className="gtr-cell text-center">
                            No records found.
                          </td>
                        </tr>
                      )}

                      {list?.map((item, index) => {
                        let created_at = new Date(item?.created_at);
                        let completed_at = new Date(item?.completed_at);
                        return (
                          <tr className="gtr-row" key={item.task_id}>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {index + 1}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {item.company_name}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell" style={{ maxWidth: 250 }}>
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {item.question}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {item.status === "completed" ? (
                                    <span className="badge bg-success">
                                      Completed
                                    </span>
                                  ) : (
                                    <span className="badge bg-warning text-dark">
                                      {item.status}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {/* {item.created_at} */}
                                  {created_at.toLocaleString("en-US", {
                                    weekday: "short",
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {/* {item.created_at} */}
                                  {completed_at.toLocaleString("en-US", {
                                    weekday: "short",
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                              </div>
                            </td>
                            <td className="gtr-cell">
                              <div className="gtr-cell-content-container">
                                <div className="gtr-cell-content">
                                  {item.status === "completed" ? (
                                    <button
                                      className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                      style={{
                                        padding: "5px 10px",
                                        backgroundColor: "rgb(35, 36, 40)",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "rgb(255, 255, 255)",
                                        border: "none",
                                        borderRadius: "6px",
                                      }}
                                      onClick={() =>
                                        handleDownload(item.task_id)
                                      }
                                    >
                                      <FeatherIcon.Download size={14} />
                                      &nbsp;Download
                                    </button>
                                  ) : (
                                    <span className="text-muted">
                                      Processing...
                                    </span>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- CREATE MODAL ---------- */}
      <div className={`modal fade ${showModal ? "show d-block" : ""}`}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Create TAM Expansion Document</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
              />
            </div>

            <div className="modal-body">
              {successMessage && (
                <Alert type="success" message={successMessage} />
              )}
              {error && <Alert type="danger" message={error} />}

              <label className="form-label fw-semibold">
                Company Name <span className="red">*</span>
              </label>
              <input
                className="form-control mb-3"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />

              <label className="form-label fw-semibold">
                Question <span className="red">*</span>
              </label>
              <textarea
                className="form-control"
                rows={4}
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                className="btn btn-primary"
                style={{ background: "#4E6BCA" }}
                onClick={handleCreate}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>

      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default TamExpansionTool;
